import type { UserAddressType } from '~/api/user';

export const userAddressToString = (
  item: Omit<UserAddressType, 'id' | 'zip'>,
  options?: { [K in keyof UserAddressType]?: boolean },
) => {
  const { t } = useI18n({ useScope: 'global' });

  return [
    options?.city !== false && t('utils.address.city', item),
    options?.street !== false && t('utils.address.street', item),
    options?.house !== false && t('utils.address.house', item),
    options?.flat !== false && item.flat && t('utils.address.flat', item),
  ]
    .filter(Boolean)
    .join(', ');
};
